import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/library/processes/$processId')({
  component: Outlet,
})
